import React from 'react';
import { LoadingOverlay } from '@/Components/shared';
import { useUserSignupNavigationContext } from '@/Context/UserSignupNavigationContext';
import EmailVerified from './EmailVerified';

function EmailVerifiedPage(): React.JSX.Element {
    const { isLoading } = useUserSignupNavigationContext();

    return isLoading ? <LoadingOverlay /> : <EmailVerified />;
}

export default EmailVerifiedPage;
